"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const content_type_1 = __importDefault(require("content-type"));
const raw_body_1 = __importDefault(require("raw-body"));
const errors_1 = require("./errors");
const rawBodyMap = new WeakMap();
async function buffer(req, { limit = '1mb' } = { limit: '1mb' }) {
    const length = req.headers['content-length'];
    const body = rawBodyMap.get(req);
    if (body) {
        return body;
    }
    try {
        const buf = await raw_body_1.default(req, { limit, length });
        rawBodyMap.set(req, buf);
        return buf;
    }
    catch (err) {
        throw new errors_1.MicriBodyError(err, limit);
    }
}
exports.buffer = buffer;
async function text(req, { limit = '1mb', encoding } = { limit: '1mb' }) {
    const type = req.headers['content-type'] || 'text/plain';
    const length = req.headers['content-length'];
    const body = rawBodyMap.get(req);
    if (body) {
        return body;
    }
    if (encoding === undefined) {
        encoding = content_type_1.default.parse(type).parameters.charset;
    }
    try {
        const buf = await raw_body_1.default(req, { limit, length, encoding });
        rawBodyMap.set(req, buf);
        return buf.toString();
    }
    catch (err) {
        throw new errors_1.MicriBodyError(err, limit);
    }
}
exports.text = text;
function parseJSON(str) {
    try {
        return JSON.parse(str);
    }
    catch (err) {
        throw new errors_1.MicriError(400, 'invalid_json', 'Invalid JSON', err);
    }
}
function json(req, opts) {
    return text(req, opts).then((body) => parseJSON(body));
}
exports.json = json;
//# sourceMappingURL=data:application/json;base64,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